// e.g /companies...
const companiesRouteRegex = new RegExp(/^\/companies.*/);

// e.g / (root) - dashboard is the index route
const dashboardRouteRegex = new RegExp(/^\/$/);

// e.g /earnings
const earningsRouteRegex = new RegExp(/^\/earnings$/);

// e.g /leaderboard
const leaderboardRouteRegex = new RegExp(/^\/leaderboard$/);

// e.g /motivation
const motivationRouteRegex = new RegExp(/^\/motivation$/);

// e.g /my-aviary
const myAviaryRouteRegex = new RegExp(/^\/my-aviary$/);

// e.g /notifications...
const notificationsRouteRegex = new RegExp(/^\/notifications.*/);

// e.g /placement-tracker
const placementTrackerRouteRegex = new RegExp(/^\/placement-tracker$/);

// e.g /job-health
const jobHealthRouteRegex = new RegExp(/^\/job-health$/);

// e.g /portfolio
const portfolioRouteRegex = new RegExp(/^\/portfolio$/);

// e.g /tools/assistant
const toolsAssistantRouteRegex = new RegExp(/^\/tools\/assistant$/);

// e.g /tools/campaigns
const toolsCampaignsRouteRegex = new RegExp(/^\/tools\/campaigns.*/);

// e.g /tools/demand
const toolsDemandRouteRegex = new RegExp(/^\/tools\/demand.*/);

// e.g /tools/demo-configs
const toolsDemoConfigsRouteRegex = new RegExp(/^\/tools\/demo-configs.*/);

// e.g /tools/explore-images
const toolsExploreImagesRouteRegex = new RegExp(/^\/tools\/explore-images$/);

// e.g /tools/sadie-dashboard
const toolsSadieDashboardRouteRegex = new RegExp(/^\/tools\/sadie-dashboard$/);

// e.g /tools/sadie-simulator
const toolsSadieSimulatorRouteRegex = new RegExp(/^\/tools\/sadie-simulator$/);

// e.g /tools/sadie-voice-simulator
const toolsSadieVoiceSimulatorRouteRegex = new RegExp(
  /^\/tools\/sadie-voice-simulator$/,
);

// e.g /tools/job-tracker
const toolsJobTrackerRouteRegex = new RegExp(/^\/tools\/job-tracker$/);

// e.g /tools/metrics
const toolsMetricsRouteRegex = new RegExp(/^\/tools\/metrics$/);

// e.g /tools/orphaned-workable-jobs
const toolsOrphanedWorkableJobsRouteRegex = new RegExp(
  /^\/tools\/orphaned-workable-jobs$/,
);

// e.g /tools...
const toolsRouteRegex = new RegExp(/^\/tools.*/);

// e.g /tools/signup-variants
const toolsSignupVariantsRouteRegex = new RegExp(/^\/tools\/signup-variants.*/);

// e.g /tools/users
const toolsUsersRouteRegex = new RegExp(/^\/tools\/users.*/);

// e.g /tools/voice-recordings
const toolsVoiceRecordingsRouteRegex = new RegExp(
  /^\/tools\/voice-recordings.*/,
);

export const routes = {
  isCompaniesRouteActive: (pathname: string) =>
    companiesRouteRegex.test(pathname),
  isDashboardRouteActive: (pathname: string) =>
    dashboardRouteRegex.test(pathname),
  isEarningsRouteActive: (pathname: string) =>
    earningsRouteRegex.test(pathname),
  isJobHealthRouteActive: (pathname: string) =>
    jobHealthRouteRegex.test(pathname),
  isLeaderboardRouteActive: (pathname: string) =>
    leaderboardRouteRegex.test(pathname),
  isMotivationRouteActive: (pathname: string) =>
    motivationRouteRegex.test(pathname),
  isMyAviaryRouteActive: (pathname: string) =>
    myAviaryRouteRegex.test(pathname),
  isNotificationsRouteActive: (pathname: string) =>
    notificationsRouteRegex.test(pathname),
  isPlacementTrackerRouteActive: (pathname: string) =>
    placementTrackerRouteRegex.test(pathname),
  isPortfolioRouteActive: (pathname: string) =>
    portfolioRouteRegex.test(pathname),
  isToolsAssistantRouteActive: (pathname: string) =>
    toolsAssistantRouteRegex.test(pathname),
  isToolsCampaignsRouteActive: (pathname: string) =>
    toolsCampaignsRouteRegex.test(pathname),
  isToolsDemandRouteActive: (pathname: string) =>
    toolsDemandRouteRegex.test(pathname),
  isToolsDemoConfigsRouteActive: (pathname: string) =>
    toolsDemoConfigsRouteRegex.test(pathname),
  isToolsExploreImagesRouteActive: (pathname: string) =>
    toolsExploreImagesRouteRegex.test(pathname),
  isToolsSadieDashboardRouteActive: (pathname: string) =>
    toolsSadieDashboardRouteRegex.test(pathname),
  isToolsSadieSimulatorRouteActive: (pathname: string) =>
    toolsSadieSimulatorRouteRegex.test(pathname),
  isToolsSadieVoiceSimulatorRouteActive: (pathname: string) =>
    toolsSadieVoiceSimulatorRouteRegex.test(pathname),
  isToolsJobTrackerRouteActive: (pathname: string) =>
    toolsJobTrackerRouteRegex.test(pathname),
  isToolsMetricsRouteActive: (pathname: string) =>
    toolsMetricsRouteRegex.test(pathname),
  isToolsOrphanedWorkableJobsRouteActive: (pathname: string) =>
    toolsOrphanedWorkableJobsRouteRegex.test(pathname),
  isToolsRouteActive: (pathname: string) => toolsRouteRegex.test(pathname),
  isToolsSignupVariantsRouteActive: (pathname: string) =>
    toolsSignupVariantsRouteRegex.test(pathname),
  isToolsUsersRouteActive: (pathname: string) =>
    toolsUsersRouteRegex.test(pathname),
  isToolsVoiceRecordingsRouteActive: (pathname: string) =>
    toolsVoiceRecordingsRouteRegex.test(pathname),
};
